import React from 'react';
import { Pagination } from 'antd';
import './PaginationComponent.css';

interface PaginationComponentProps {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (page: number, size?: number) => void;
  showSizeChanger?: boolean;
  showQuickJumper?: boolean;
  showTotal?: boolean;
  pageSizeOptions?: string[];
  itemName?: string; // e.g., 'applications', 'internships', 'mentors'
  className?: string;
  style?: React.CSSProperties;
}

const PaginationComponent: React.FC<PaginationComponentProps> = ({
  currentPage,
  pageSize,
  totalItems,
  onPageChange,
  showSizeChanger = true,
  showQuickJumper = true,
  showTotal = true,
  pageSizeOptions = ['5', '10', '20', '50'],
  itemName = 'items',
  className = '',
  style = {}
}) => {
  const handlePageChange = (page: number, size?: number) => {
    onPageChange(page, size);
  };

  const renderShowTotal = (total: number, range: [number, number]) => {
    const searchTerm = ''; // You can pass this as a prop if needed
    return `${range[0]}-${range[1]} of ${total} ${searchTerm.trim() ? 'results' : itemName}`;
  };

  if (totalItems === 0) {
    return null;
  }

  return (
    <div 
      className={`pagination-container ${className}`}
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: 24,
        padding: '16px 0',
        ...style
      }}
    >
      <Pagination
        current={currentPage}
        total={totalItems}
        pageSize={pageSize}
        onChange={handlePageChange}
        onShowSizeChange={handlePageChange}
        showSizeChanger={showSizeChanger}
        showQuickJumper={showQuickJumper}
        showTotal={showTotal ? renderShowTotal : undefined}
        pageSizeOptions={pageSizeOptions}
        size="default"
      />
    </div>
  );
};

export default PaginationComponent;
